import React from 'react';
import { VerticalSeparator } from '../components/separators';
import { Link } from 'react-router-dom';
import '../pages/housePage.css'

function AreYouInterestedComponent(props) {

    const { selectedLanguage } = props;

  return (
    <div style={{ alignItems: 'center', textAlign: 'center', backgroundColor: '#e0e0e0', marginLeft: '12px', marginRight: '12px', borderRadius: '12px' }}>
        <VerticalSeparator height={"4vw"}></VerticalSeparator>
        <div style={{ marginLeft: '12px', marginRight: '12px' }}>
          <h1 className='text-h-housepage-class'>{selectedLanguage === 'ita' ? "Ti interessa affitare la casa?" : "Are you interested in renting the house?"}</h1>
          <p className='text-p-housepage-class'>{selectedLanguage === 'ita' ? "Per informazioni sulle disponibilità" : "For information on availability"}</p>
          <Link to="/contacts" className="btn btn-primary">{selectedLanguage === 'ita' ? "Contattaci" : "Contacts us"}</Link>
        </div>
        <VerticalSeparator height={"4vw"}></VerticalSeparator>
      </div>
  );
}

export default AreYouInterestedComponent;